import React from 'react';

import {UpdateTaskParams} from 'processes/process-task-details/utils/updateTaskDetailsTask';

import StatusField from '../fields/StatusField';
import {
  ProcessTaskDetailsRowContent,
  getProcessTaskDetailsLabels,
  ProcessTaskGql,
} from '../ProcessTaskDetailsPageConstants';

export function getProcedureRunTaskDetailsSummaryRows(
  processTask: ProcessTaskGql,
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>,
  procedureTemplateContent: ProcessTaskDetailsRowContent
): Array<ProcessTaskDetailsRowContent> {
  return [
    {
      label: getProcessTaskDetailsLabels().STATUS,
      component: <StatusField processTask={processTask} onUpdateTask={onUpdateTask} />,
    },
    procedureTemplateContent,
  ];
}
